<div>
  <div
    class="flex flex-wrap items-center justify-between gap-3 text-sm font-medium text-[#3a3a3a]">
    @if (withLabel()) {
      <span>Ankieta dostępna do:</span>
    }

    <span>
      {{ endDate() | date: 'dd.MM.yyyy, HH:mm' }}
    </span>

    @if (isEnding()) {
      <span class="text-[#dc6b95]">Trwa zamykanie ankiety...</span>
    }
  </div>

  @if (withProgressBar()) {
    <div class="mt-3 h-2 overflow-hidden rounded-full bg-[#f1d7e2]">
      <div
        class="h-full bg-[#dc6b95] transition-[width] duration-1000"
        [style.width.%]="progress()"></div>
    </div>
  }
</div>
